module.exports = __webpack_public_path__ + "img/weiyuanLvzhi.a76a9d2a.png";